const RECEIVE_ADPLATFORMS = 'src/adPlatforms/RECEIVE_ADPLATFORMS';
const CLEAR_ADPLATFORMS = 'src/adPlatforms/CLEAR_ADPLATFORMS';

export default {
  CLEAR_ADPLATFORMS,
  RECEIVE_ADPLATFORMS
};
